import React, { useState, useRef } from 'react';
import { Form, Button, Container, Row, Col, Spinner } from 'react-bootstrap';
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.min.css';
import ManagerService from '../../services/ManagerService';
import * as XLSX from 'xlsx'; // Import thư viện xlsx

const LoTrinhNhapComponent = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLoading, setIsLoading] = useState(false); 
  const containerRef = useRef(null);
  const hotInstance = useRef(null);

  const formatDateToDDMMYYYY = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}_${month}_${year}`; // Định dạng dd_mm_yyyy cho tên file
  };

  const timKiem = async () => {
    if (!startDate || !endDate) {
      alert('Vui lòng chọn ngày');
      return;
    }
    setIsLoading(true); 
    try {
      const formattedStartDate = formatDateToDDMMYYYY(startDate);
      const formattedEndDate = formatDateToDDMMYYYY(endDate);
      const data = await ManagerService.getLoTrinhNhap(startDate, endDate);

      const columnsConfig = data.columns.map(() => ({ readOnly: true }));
      hotInstance.current = new Handsontable(containerRef.current, {
        data: data.data,
        colHeaders: data.columns,
        rowHeaders: true,
        filters: true,
        dropdownMenu: true,
        stretchH: 'all',
        autoColumnSize: true,
        manualRowResize: true,
        manualColumnResize: true,
        columns: columnsConfig,
        licenseKey: 'non-commercial-and-evaluation',
      });
    } catch (error) {
      console.error('Lỗi khi tìm kiếm:', error);
    } finally {
      setIsLoading(false); 
    }
  };

  const exportToExcel = () => {
    if (hotInstance.current) {
      const exportData = hotInstance.current.getData(); // Lấy tất cả dữ liệu từ Handsontable
      const headers = hotInstance.current.getColHeader(); // Lấy tiêu đề cột
      
      // Chuyển đổi dữ liệu thành định dạng bảng cho Excel
      const worksheetData = [headers, ...exportData];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'LoTrinhNhap');

      // Định dạng tên file dựa trên ngày bắt đầu và kết thúc
      const formattedStartDate = formatDateToDDMMYYYY(startDate);
      const formattedEndDate = formatDateToDDMMYYYY(endDate);
      const fileName = `Thong_tin_nhap_lieu_tu_tai_xe_${formattedStartDate}_${formattedEndDate}.xlsx`;

      // Sử dụng XLSX.writeFile để tạo và tải file Excel
      XLSX.writeFile(workbook, fileName);
    } else {
      console.error('Không có dữ liệu để xuất Excel');
    }
  };

  return (
    <Container fluid className="my-4">
      <h2 className="text-center mb-4">Lấy lộ trình nhập</h2>

      <Form>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="startDate">
              <Form.Label>Ngày bắt đầu:</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="endDate">
              <Form.Label>Ngày kết thúc:</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Button
          variant="danger"
          onClick={timKiem}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Đang tìm kiếm...
            </>
          ) : (
            'Lấy lộ trình nhập'
          )}
        </Button>
      </Form>

      <div id="excelGrid" ref={containerRef} className="mt-4"></div>

      <Button variant="success" className="mt-3" onClick={exportToExcel}>
        Xuất Excel
      </Button>
    </Container>
  );
};

export default LoTrinhNhapComponent;
